import React, { useEffect, useState, useRef } from "react";
import { TopBanner } from "./TopBanner";
import { toAbsoluteUrl } from "sr/helpers";
import { ModelWrapperWithButton } from "../../component/ModelWrapperWithButton";
import { ReviewDataEdit } from "./ReviewDataEdit";
import { CompanyNameChange } from "./Model/CompanyNameChange";
import { JobTitleChange } from "./Model/JobTitleChange";
import PayChange from "./Model/PayChange";
import { HireNumberChange } from "./Model/HireNumberChange";
import { HireTimelineChange } from "./Model/HireTimelineChange";
import { ScheduleChange } from "./Model/ScheduleChange";
import { BenifitsChange } from "./Model/BenifitsChange";
import { JobDescription } from "./Model/JobDescription";
import { SupplementalPayChange } from "./Model/SupplementalPayChange";
import { Notification } from "./Model/Notification";
import { FormattedMessage, useIntl } from "react-intl";
import { StartDate } from "./Model/StartDate";
import { MobileNumberChange } from "./Model/MobileNumberChange";
import { RequireResume } from "./Model/RequireResume";
import { ReportWorkLocation } from "./ReportWorkLocation";
import { ApplicationDeadline } from "./Model/ApplicationDeadline";
import { MainWrapper } from "../../component/MainWrapper";
import { useNavigate, useParams } from "react-router-dom";
import { getJobs } from "sr/utils/api/cleaner/jobs/getJobs";
import { updateBasicDetails } from "sr/utils/api/cleaner/company/jobPost/updateBasicDetails";
import { updateAdvanceDetails } from "sr/utils/api/cleaner/company/jobPost/updateAdvanceDetails";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { EmploymentTypeChange } from "./Model/EmploymentTypeChange";
import { JobTypeChange } from "./JobTypeChange";
import { DateFormat } from "sr/helpers/functions/DateFormat";
import { addAdvanceDetails } from "sr/utils/api/cleaner/company/jobPost/addAdvanceDetails";
import _ from "lodash";
import { toast } from "react-toastify";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import { getJobTypeCategory } from "sr/utils/api/getJobTypeCategory";
import {
  benifitdata,
  employment,
  Schedule,
  supplementalpaydata,
} from "./Jsonalldata";
import { payTypes } from "sr/i18n/messages/setting";
import getLabelByValue from "sr/helpers/functions/getLabelByValue";
import moment from "moment";
import sortAlpha from "sr/helpers/functions/sortAlpha";
import { AdditionalRegionsChange } from "./Model/AdditionalRegionsChange";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "sr/redux/store";
import { fetchprovince } from "sr/redux/action/master/provinceAction";
import { RegionChips } from "sr/helpers/ui-components/RegionChips";
import { TrainingCertificationRequirementWarning } from "sr/helpers/ui-components/company/TrainingCertificationRequirementWarning";
import { getGeneralType } from "sr/utils/api/getGeneralType";
import TrainingCertificationChange from "./Model/TrainingCertificationChange";
export const Review = () => {
  const [jobId, setJobId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeComponent, setActiveComponent] = useState<any>({});
  const [jobData, setJobData] = useState<any>({});
  const [updateData, setUpdateData] = useState<any>({});
  const [loader, setLoader] = useState(false);
  const childRef = useRef(null);
  const intl = useIntl();
  const provinceData = useSelector((s: RootState) => s.province?.data);
  const dispatch = useDispatch<AppDispatch>();
  const [trainingLabelsById, setTrainingLabelsById] = useState<Record<string, string>>({});
  const [certificationLabelsById, setCertificationLabelsById] = useState<Record<string, string>>({});
  useEffect(() => {
    if (!provinceData) dispatch(fetchprovince());
  }, [provinceData, dispatch]);

  useEffect(() => {
    const mapLabels = (items: any[] = []) => {
      const entries = items
        .map(
          (item) =>
            [
              String(item?._id || item?.id || ""),
              String(item?.title || item?.label || ""),
            ] as const,
        )
        .filter(([key, val]) => key && val);
      return Object.fromEntries(entries);
    };

    const fetchTrainingCertificationLabels = async () => {
      try {
        const [trainingResponse, certificationResponse] = await Promise.all([
          getGeneralType("cleanerTrainings"),
          getGeneralType("cleanerCertifications"),
        ]);
        setTrainingLabelsById(mapLabels(trainingResponse?.data || []));
        setCertificationLabelsById(mapLabels(certificationResponse?.data || []));
      } catch (e: any) {}
    };

    fetchTrainingCertificationLabels();
  }, []);

  useEffect(() => {
    if (!showModal) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [showModal]);

  const navigate = useNavigate();
  const HandleModel = (data: any) => {
    setShowModal(data);
  };
  const HandleDataProps = (data) => {
    setUpdateData(data);
  };

  const AllModels = [
    {
      label: "JobTitleChange",
      componentName: JobTitleChange,
    },
    {
      label: "CompanyNameChange",
      componentName: CompanyNameChange,
    },
    {
      label: "EmploymentTypeChange",
      componentName: EmploymentTypeChange,
    },
    {
      label: "JobTypeChange",
      componentName: JobTypeChange,
    },
    {
      label: "ScheduleChange",
      componentName: ScheduleChange,
    },
    { label: "Startdate", componentName: StartDate },
    {
      label: "PayChange",
      componentName: PayChange,
    },
    {
      label: "BenifitsChange",
      componentName: BenifitsChange,
    },
    {
      label: "JobDescription",
      componentName: JobDescription,
    },
    {
      label: "MobileNumberChange",
      componentName: MobileNumberChange,
    },
    {
      label: "RequireResume",
      componentName: RequireResume,
    },
    {
      label: "Notification",
      componentName: Notification,
    },
    {
      label: "ReportWorkLocation",
      componentName: ReportWorkLocation,
    },
    {
      label: "HireNumberChange",
      componentName: HireNumberChange,
    },
    {
      label: "HireTimelineChange",
      componentName: HireTimelineChange,
    },

    {
      label: "SupplementalPayChange",
      componentName: SupplementalPayChange,
    },

    {
      label: "ApplicationDeadline",
      componentName: ApplicationDeadline,
    },
    {
      label: "AdditionalRegionsChange",
      componentName: AdditionalRegionsChange,
    },
    {
      label: "TrainingCertificationChange",
      componentName: TrainingCertificationChange,
    },
  ];
  const JobDescriptionComponent = ({ jobDescription }) => {
    return (
      <div
        className="job-description"
        dangerouslySetInnerHTML={{ __html: jobDescription }}
      />
    );
  };
  const showTrainingCertificationWarning =
    Boolean(jobData?.require_certification_training) &&
    ((Array.isArray(jobData?.certifications) ? jobData.certifications.length : 0) >
      0 ||
      (Array.isArray(jobData?.trainings) ? jobData.trainings.length : 0) > 0);

  const openModel = (index: any) => {
    const activeComp = AllModels.filter(function (e, i) {
      return i == index;
    });

    setActiveComponent(activeComp[0]);
    setShowModal(true);
  };
  const params = useParams();

  useEffect(() => {
    const { job_id } = params;
    setJobId(job_id);
  }, []);
  const fetchData = async (id: any) => {
    setLoader(true);
    const queryParams = new URLSearchParams();
    queryParams.append("id", id.toString());
    try {
      const result = await getJobs(queryParams);
      if (result?.success === true) {
        setJobData(result?.data);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (jobId) {
      fetchData(jobId);
    }
  }, [jobId]);
  const checkApi = (jobData, updateData) => {
    for (const key of Object.keys(jobData)) {
      if (Object.keys(updateData).includes(key)) {
        return "job";
      } else {
        if (jobData["job_advanced_id"]) {
          for (const key of Object.keys(jobData["job_advanced_id"])) {
            if (Object.keys(updateData).includes(key)) {
              return "job_advanced_id";
            }
          }
        } else {
          return "job_advanced_id";
        }
      }

      if (
        Object.keys(updateData).includes("hire_count") ||
        Object.keys(updateData).includes("recruitment_timeline") ||
        Object.keys(updateData).includes("application_deadline")
      ) {
        return "job_advanced_id";
      }
    }
  };

  const HandleSave = async () => {
    let isValidData = null;
    if (childRef.current && childRef.current.validateData) {
      isValidData = await childRef.current.validateData(updateData);
    }
    if (childRef.current && childRef.current.submitForm) {
      await childRef.current.submitForm();
    }
    if (
      (_.isBoolean(isValidData) && isValidData) ||
      !_.isBoolean(isValidData)
    ) {
      const apineed = checkApi(jobData, updateData);
      const data = { id: jobId, ...updateData };
      const datas = { job_id: jobId, ...updateData };
      if (apineed === "job") {
        const result = await updateBasicDetails(data);
        if (result?.success === true) {
          setShowModal(false);
          fetchData(jobId);
        }
      } else if (apineed === "job_advanced_id") {
        let result;
        if (!jobData["job_advanced_id"]) {
          if (datas?.reporting_address) {
            if (!datas?.reporting_address?.address_line_1) {
              toast.error("Please Enter Address");
              return;
            }
          }

          result = await addAdvanceDetails(datas);
        } else {
          if (datas?.reporting_address) {
            if (!datas?.reporting_address?.address_line_1) {
              toast.error("Please Enter Address");
              return;
            }
          }
          result = await updateAdvanceDetails(datas);
        }
        if (result?.success === true) {
          setShowModal(false);
          fetchData(jobId);
        }
      }
    }
  };

  const minAmount = jobData?.min_amount;
  const maxAmount = jobData?.max_amount;
  const exactAmount = jobData?.exact_amount;
  const rangeValue =
    minAmount && maxAmount
      ? `$${jobData?.min_amount?.toFixed(2)}-$${jobData?.max_amount?.toFixed(
          2
        )} ${jobData?.rate}`
      : "";
  let notRangeValue = "";
  if (minAmount) {
    notRangeValue = `Starting from $${minAmount.toFixed(2)} ${jobData?.rate}`;
  } else if (maxAmount) {
    notRangeValue = `Up to $${maxAmount.toFixed(2)} ${jobData?.rate}`;
  } else if (exactAmount) {
    notRangeValue = `$${exactAmount.toFixed(2)} ${jobData?.rate}`;
  }
  const payValue =
    jobData?.show_pay_by === "Range" ? rangeValue : notRangeValue;
  const reportingAddress = jobData?.job_advanced_id?.reporting_address;
  const addressLine1 = reportingAddress?.address_line_1;
  const addressLine2 = reportingAddress?.address_line_2;
  const city = reportingAddress?.city;
  const state = reportingAddress?.state;
  const country = reportingAddress?.country;
  const postal = reportingAddress?.postal;
  const addressArray = [
    addressLine1,
    addressLine2,
    city,
    state,
    country,
    postal,
  ];
  const formattedReportingAddress = (
    <span>
      {addressArray
        ?.filter((value) => value)
        ?.toString()
        ?.replaceAll(",", ", ")}
    </span>
  );

  const reportingRegions: string[] = Array.isArray(
    jobData?.job_advanced_id?.reporting_regions
  )
    ? jobData.job_advanced_id.reporting_regions
        .map((r: any) => String(r?.id || r?._id || r || ""))
        .filter(Boolean)
    : [];

  const additionalRegionsModelIndex = AllModels.findIndex(
    (m) => m.label === "AdditionalRegionsChange"
  );
  const trainingCertificationModelIndex = AllModels.findIndex(
    (m) => m.label === "TrainingCertificationChange"
  );

  const handleJob = async () => {
    try {
      setLoader(true);
      const payload = {
        status: "open",
        id: jobId,
      };
      const res = await updateBasicDetails(payload);
      if (res?.success === true) {
        setLoader(false);
        SuccessMessage("API.SUCCESS.BASICJOB.DETAILS.POSTED");
        navigate("/jobs-listing");
      } else {
        setLoader(false);
      }
    } catch (e) {
      setLoader(false);
    }
  };
  const [jobTypes, setJobTypes] = useState([]);
  useEffect(() => {
    const fetchJobType = async () => {
      try {
        const res = await getJobTypeCategory();
        if (res?.success === true) {
          setJobTypes(res?.data);
        }
      } catch (e: any) {}
    };
    fetchJobType();
  }, []);
  const options = jobTypes?.map((item) => ({
    value: item?.value, // Assuming `value` exists
    label: <FormattedMessage id={item?.label} />,
  }));

  const payTypeLabel = jobData?.rate
    ? intl.formatMessage({ id: getLabelByValue(jobData?.rate, payTypes) })
    : "";

  const value =
    jobData?.show_pay_by === "Range"
      ? `${jobData?.min_amount?.toFixed(2)}-${jobData?.max_amount?.toFixed(2)}`
      : (jobData?.min_amount ? jobData?.min_amount.toFixed(2) : "") ||
        (jobData?.max_amount ? jobData?.max_amount.toFixed(2) : "") ||
        jobData?.exact_amount?.toFixed(2) ||
        "";
  const sortedJobType = sortAlpha(jobData?.job_type);

  return (
    <MainWrapper>
      <div className="bg-white">
        <div className="pt-10 container mx-auto max-w-3xl">
          <TopBanner
            img={toAbsoluteUrl("/media/img/jobpost.png")}
            text={
              <FormattedMessage
                id="RECRUITER.POSTJOB.REVIEW.TITLE"
                defaultMessage="Review"
              />
            }
          ></TopBanner>
          {/* <div className={`flex items-center h-14 rounded-lg space-x-4 px-4 py-10 border bg-[#FDEFE9] border-[#F7C9B3] my-4`}>
    <svg xmlns="http://www.w3.org/2000/svg" focusable="false" role="img" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" className="w-5 h-5 text-[#B16300]"><path fillRule="evenodd" d="M12.432 2.248a.5.5 0 00-.864 0l-10.5 19a.5.5 0 00.433.752H22.5a.5.5 0 00.432-.752l-10.5-19zm.569 12.502a.25.25 0 01-.25.25h-1.5a.25.25 0 01-.25-.25v-5.5a.25.25 0 01.25-.25h1.5a.25.25 0 01.25.25v5.5zm0 4a.25.25 0 01-.25.25h-1.5a.25.25 0 01-.25-.25v-1.5a.25.25 0 01.25-.25h1.5a.25.25 0 01.25.25v1.5z" clipRule="evenodd"></path></svg>
         <div className='flex-1'>
          <div>
        <span className=' text-base'>
        <FormattedMessage id="RECRUITER.POSTJOB.REVIEW.MISSING.WARNING.TITLE" defaultMessage="Job post has missing information" />  
        </span>
        <p className='text-sm '>
        <FormattedMessage id="RECRUITER.POSTJOB.REVIEW.MISSING.WARNING.TEXT" defaultMessage="To improve this post, add information that's important to people applying." />

        </p></div></div>
<div className='flex  cursor-pointer text-[#0078ae]'>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
</svg>
<span><FormattedMessage id="RECRUITER.POSTJOB.REVIEW.ADD.BUTTON" defaultMessage="Add" /></span>
</div>
    </div> */}
          <ContentWithSpinner loader={loader} height="h-screen">
            <div className="pt-8 pb-4 flex items-center space-x-4">
              <h1 className="text-2xl ">{jobData?.job_title}</h1>
              <svg
                onClick={() => openModel(0)}
                xmlns="http://www.w3.org/2000/svg"
                focusable="false"
                role="img"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
                className="w-5 h-5 text-[#0078ae] cursor-pointer"
              >
                <path d="M20.706 7.042a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83zm-2.898 2.9l-9.705 9.71a.5.5 0 01-.218.128l-4.246 1.2a.5.5 0 01-.618-.616l1.209-4.24a.5.5 0 01.127-.216l9.7-9.716 3.75 3.75z"></path>
              </svg>
            </div>
            <div className="py-1 flex items-center space-x-4">
              <p className="text-base ">{jobData?.company_id?.company_name}</p>
              {/* <svg onClick={() => openModel(1)} xmlns="http://www.w3.org/1000/svg" focusable="false" role="img" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" className="w-5 h-5 text-[#0078ae] cursor-pointer"><path d="M20.706 7.042a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83zm-2.898 2.9l-9.705 9.71a.5.5 0 01-.218.128l-4.246 1.2a.5.5 0 01-.618-.616l1.209-4.24a.5.5 0 01.127-.216l9.7-9.716 3.75 3.75z"></path></svg> */}
            </div>
            <hr className="my-10 border-neutral-200" />
            <div className="pb-4">
              <h2 className="text-xl  pb-2">
                <FormattedMessage
                  id="RECRUITER.POSTJOB.REVIEW.JOBDETAILS.TITLE"
                  defaultMessage="Job Details"
                />
              </h2>

              <ReviewDataEdit
                title={
                  <FormattedMessage
                    id="RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.EMPTYPE.TITLE"
                    defaultMessage="Employment Type"
                  />
                }
                multivalue={jobData?.employment_type}
                allData={employment}
                onClick={() => openModel(2)}
              />
              <ReviewDataEdit
                title={
                  <FormattedMessage
                    id="RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.JOBTYPE.TITLE"
                    defaultMessage="Job type"
                  />
                }
                allData={options}
                name="jobType"
                multivalue={sortedJobType}
                onClick={() => openModel(3)}
              />
              <ReviewDataEdit
                title={
                  <FormattedMessage
                    id="RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENEFITS.FLEXIBLE_SCHEDULE"
                    defaultMessage="Flexible schedule"
                  />
                }
                multivalue={jobData?.schedule}
                onClick={() => openModel(4)}
                allData={Schedule}
              />

              {/* Hiding Job Start date field for Jira https://vikram-bryt.atlassian.net/browse/JMN-151 */}

              {/* <ReviewDataEdit 
           title = {<FormattedMessage id="RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.PLANNEDDATE.TITLE" defaultMessage="Start Date" />}
           value={DateFormat(jobData?.start_date)}
            onClick={()=> {openModel(5)}}> 
            </ReviewDataEdit> */}
              <ReviewDataEdit
                title={
                  <FormattedMessage
                    id="RECRUITER.POSTJOB.ADDPAYBENIFIT.PAY.TITLE"
                    defaultMessage="Pay"
                  />
                }
                value={`${value} ${payTypeLabel}`}
                allData={payTypes}
                onClick={() => {
                  openModel(6);
                }}
              ></ReviewDataEdit>

              <ReviewDataEdit
                title={
                  <FormattedMessage
                    id="RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENIFITS"
                    defaultMessage="Benefits"
                  />
                }
                multivalue={jobData?.benefits}
                allData={benifitdata}
                onClick={() => openModel(7)}
              />

              <ReviewDataEdit
                title={
                  <FormattedMessage
                    id="RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.SUPPLEMENTALPAY"
                    defaultMessage="Supplemental Pay"
                  />
                }
                multivalue={jobData?.supplemental_pay}
                allData={supplementalpaydata}
                onClick={() => openModel(15)}
              />

              <div>
                <div className="py-1 flex items-center space-x-4">
                  <h2 className="text-base ">
                    <FormattedMessage
                      id="RECRUITER.POSTJOB.JOBDESCRIPTION.TITLE"
                      defaultMessage="Job Description"
                    />
                  </h2>
                  <svg
                    onClick={() => openModel(8)}
                    xmlns="http://www.w3.org/1000/svg"
                    focusable="false"
                    role="img"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    className="w-5 h-5 text-[#0078ae] cursor-pointer"
                  >
                    <path d="M20.706 7.042a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83zm-2.898 2.9l-9.705 9.71a.5.5 0 01-.218.128l-4.246 1.2a.5.5 0 01-.618-.616l1.209-4.24a.5.5 0 01.127-.216l9.7-9.716 3.75 3.75z"></path>
                  </svg>
                </div>
                <JobDescriptionComponent
                  jobDescription={jobData?.job_description}
                />{" "}
              </div>
              <ReviewDataEdit
                title={
                  <FormattedMessage
                    id="RECRUITER.POSTJOB.SETPREFERENCE.CALL"
                    defaultMessage="Let applicants call you directly for this job"
                  />
                }
                value={jobData?.application_call_mobile_number}
                onClick={() => openModel(9)}
              />
              <ReviewDataEdit
                title={
                  <FormattedMessage
                    id="RECRUITER.POSTJOB.SETPREFERENCE.INPUT.REQUIRERESUME.TITLE"
                    defaultMessage="Require a resume to apply?"
                  />
                }
                value={jobData?.require_resume ? "Yes" : "No"}
                onClick={() => openModel(10)}
              />
              <div className="mt-4">
                <div className="py-1 flex items-center space-x-4">
                  <p className="text-base">
                    <FormattedMessage
                      id="RECRUITER.POSTJOB.REQUIRED.TRAINING_CERTIFICATION.TITLE"
                      defaultMessage="Any required trainings or certifications?"
                    />
                    :{" "}
                    {jobData?.require_certification_training ? (
                      <FormattedMessage
                        id="RECRUITER.POSTJOB.REQUIRED.TRAINING_CERTIFICATION.YES"
                        defaultMessage="Yes"
                      />
                    ) : (
                      <FormattedMessage
                        id="RECRUITER.POSTJOB.REQUIRED.TRAINING_CERTIFICATION.NO"
                        defaultMessage="No"
                      />
                    )}
                  </p>
                  {trainingCertificationModelIndex >= 0 && (
                    <svg
                      onClick={() => openModel(trainingCertificationModelIndex)}
                      xmlns="http://www.w3.org/1000/svg"
                      focusable="false"
                      role="img"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      className="w-5 h-5 text-[#0078ae] cursor-pointer"
                    >
                      <path d="M20.706 7.042a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83zm-2.898 2.9l-9.705 9.71a.5.5 0 01-.218.128l-4.246 1.2a.5.5 0 01-.618-.616l1.209-4.24a.5.5 0 01.127-.216l9.7-9.716 3.75 3.75z"></path>
                    </svg>
                  )}
                </div>

                {jobData?.require_certification_training && (
                  <>
                    {((jobData?.trainings?.length || 0) > 0 ||
                      (jobData?.certifications?.length || 0) > 0) && (
                      <div className="mt-3 rounded-lg border border-neutral-200 bg-white p-4">
                        {(jobData?.trainings?.length || 0) > 0 && (
                          <div
                            className={`${
                              (jobData?.certifications?.length || 0) > 0
                                ? "pb-4 border-b border-neutral-200"
                                : ""
                            }`}
                          >
                            <h4 className="text-base font-bold">
                              <FormattedMessage
                                id="RECRUITER.POSTJOB.REQUIRED.TRAINING_CERTIFICATION.TRAININGS"
                                defaultMessage="Required trainings"
                              />
                            </h4>
                            <p className="mt-2">
                              {(jobData?.trainings || [])
                                .map(
                                  (item) =>
                                    trainingLabelsById?.[String(item)] || String(item),
                                )
                                .join(", ")}
                            </p>
                          </div>
                        )}

                        {(jobData?.certifications?.length || 0) > 0 && (
                          <div
                            className={`${
                              (jobData?.trainings?.length || 0) > 0 ? "pt-4" : ""
                            }`}
                          >
                            <h4 className="text-base font-bold">
                              <FormattedMessage
                                id="RECRUITER.POSTJOB.REQUIRED.TRAINING_CERTIFICATION.CERTIFICATIONS"
                                defaultMessage="Required certifications"
                              />
                            </h4>
                            <p className="mt-2">
                              {(jobData?.certifications || [])
                                .map(
                                  (item) =>
                                    certificationLabelsById?.[String(item)] ||
                                    String(item),
                                )
                                .join(", ")}
                            </p>
                          </div>
                        )}
                      </div>
                    )}

                    {showTrainingCertificationWarning && (
                      <div className="mt-4">
                        <TrainingCertificationRequirementWarning />
                      </div>
                    )}
                  </>
                )}
              </div>
              {/* <ReviewDataEdit
        title={<FormattedMessage id="RECRUITER.POSTJOB.SETPREFERENCE.NOTIFICATION.TITLE" defaultMessage="Notification" />}
        value={jobData?.notifications ? 'Yes':'No'}
        onClick={() => openModel(11)}
      /> */}
              <hr className="my-10 border-neutral-200" />
              <div className="pb-4">
                <h2 className="text-xl  pb-2">
                  <FormattedMessage
                    id="RECRUITER.POSTJOB.ADVANCEDETAILS.TITLE"
                    defaultMessage="Advanced Details"
                  />
                </h2>
              </div>
              <ReviewDataEdit
                title={
                  <FormattedMessage
                    id="RECRUITER.POSTJOB.REVIEW.NOOF.TITLE"
                    defaultMessage="Number of people to hire for this job"
                  />
                }
                value={jobData?.job_advanced_id?.hire_count}
                onClick={() => openModel(13)}
              />
              <ReviewDataEdit
                title={
                  <FormattedMessage
                    id="RECRUITER.POSTJOB.REVIEW.HIRINGTIME_LINE.TITLE"
                    defaultMessage="Hiring timeline for this job"
                  />
                }
                value={moment(
                  jobData?.job_advanced_id?.recruitment_timeline
                ).format("MM/DD/YYYY")}
                onClick={() => openModel(14)}
              />

              <ReviewDataEdit
                title={
                  <FormattedMessage
                    id="RECRUITER.POSTJOB.SETPREFERENCE.INPUT.APPLICATION.DEADLINE"
                    defaultMessage="Accepting applications until"
                  />
                }
                value={DateFormat(
                  jobData?.job_advanced_id?.application_deadline
                )}
                onClick={() => openModel(16)}
              />
              <ReviewDataEdit
                title={
                  <FormattedMessage
                    id="RECRUITER.POSTJOB.INPUT.REPORTWORK"
                    defaultMessage="Where will an employee report to work?"
                  />
                }
                value={formattedReportingAddress}
                onClick={() => openModel(12)}
              />
              <div className="py-2">
                <div className="py-1 flex items-center space-x-4">
                  <p className="text-base ">
                    <FormattedMessage
                      id="RECRUITER.POSTJOB.ADVANCEDETAILS.REPORTING.REGIONS"
                      defaultMessage="Additional Regions"
                    />
                  </p>
                  {additionalRegionsModelIndex >= 0 ? (
                    <svg
                      onClick={() => openModel(additionalRegionsModelIndex)}
                      xmlns="http://www.w3.org/1000/svg"
                      focusable="false"
                      role="img"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      className="w-5 h-5 text-[#0078ae] cursor-pointer"
                    >
                      <path d="M20.706 7.042a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83zm-2.898 2.9l-9.705 9.71a.5.5 0 01-.218.128l-4.246 1.2a.5.5 0 01-.618-.616l1.209-4.24a.5.5 0 01.127-.216l9.7-9.716 3.75 3.75z"></path>
                    </svg>
                  ) : null}
                </div>
                <div className="flex flex-wrap gap-2">
                  <RegionChips regionIds={reportingRegions} />
                </div>
              </div>
            </div>

            {/* <div className='mt-10 mb-5 py-10 border-y border-neutral-200 flex items-center justify-between'>
    <div>  
<div className='text-xl pb-2 '>
<FormattedMessage id="RECRUITER.POSTJOB.REVIEW.SETTING.TITLE" defaultMessage="Setting" />
</div>
<p className=''><FormattedMessage id="RECRUITER.POSTJOB.REVIEW.SETTING.TEXT" defaultMessage="The following information will not be shared on your job post." /></p>
</div>
<svg className="w-24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 117 73" aria-hidden="true" data-testid="ipl-illustration-spot"><defs><filter id="ipl-illustrations-spot-:r1o:-4" x="0%" y="0%"><feTurbulence baseFrequency="2.5" numOctaves="4" result="noise" seed="14"></feTurbulence><feComponentTransfer in="noise" result="opacity"><feFuncA slope="0.6" type="linear"></feFuncA></feComponentTransfer><feBlend in="opacity" in2="SourceGraphic" mode="overlay" result="blend"></feBlend></filter><filter id="ipl-illustrations-spot-:r1o:-3" width="30.884" height="30.906" x="46.479" y="14.111" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix><feOffset dx="1" dy="1"></feOffset><feGaussianBlur stdDeviation="0.5"></feGaussianBlur><feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"></feColorMatrix><feBlend in2="shape" result="effect1_innerShadow_4373_1608"></feBlend></filter><filter id="ipl-illustrations-spot-:r1o:-2" width="20.694" height="25.355" x="51.542" y="19.662" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix><feOffset dx="1" dy="1"></feOffset><feGaussianBlur stdDeviation="0.5"></feGaussianBlur><feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"></feColorMatrix><feBlend in2="shape" result="effect1_innerShadow_4373_1608"></feBlend></filter><clipPath id="ipl-illustrations-spot-:r1o:-1"><path xmlns="http://www.w3.org/2000/svg" fill="#fff" d="M35.423 1.85c0-.674.547-1.222 1.222-1.222h49.552c.675 0 1.222.548 1.222 1.222v8.547l20.132-2.719 9 63.23H87.419v.509c0 .674-.547 1.222-1.222 1.222H36.645a1.222 1.222 0 0 1-1.222-1.222v-.51H.263L10.987 20.72l24.436-3.3V1.85z"></path></clipPath><pattern id="ipl-illustrations-spot-:r1o:-0" width="50" height="40" x="0" y="0" patternTransform="scale(.3)" patternUnits="userSpaceOnUse"><path d="M0 0h50v40H0z" filter="url(#ipl-illustrations-spot-:r1o:-4)"></path></pattern></defs><g clip-path="url(#ipl-illustrations-spot-:r1o:-1)"><path fill="#B6D7EE" d="m10.987 20.719 96.564-13.04 9 63.228H.263L10.987 20.72z"></path><rect width="51.996" height="72.01" x="35.423" y="0.628" fill="#0078ae" rx="1.222"></rect><g filter="url(#ipl-illustrations-spot-:r1o:-3)"><path fill="#FCFEFF" d="M61.421 44.016c8.252 0 14.942-6.694 14.942-14.952 0-8.259-6.69-14.953-14.942-14.953-8.252 0-14.942 6.694-14.942 14.953 0 8.258 6.69 14.952 14.942 14.952z"></path></g><path fill="#C7D2F6" d="M46.444 51.935h23.925v3.8H46.444zM46.445 58.775h29.884v3.8H46.445z"></path><g filter="url(#ipl-illustrations-spot-:r1o:-2)"><path fill="#E0A961" d="M71.236 40.339a14.878 14.878 0 0 1-9.815 3.678c-3.787 0-7.245-1.41-9.879-3.734V39.6c0-3.57 3.338-6.55 7.788-7.265a6.503 6.503 0 1 1 4.116 0c4.451.713 7.79 3.695 7.79 7.265v.739z"></path></g><rect width="14.799" height="2.985" x="54.021" y="4.694" fill="#fff" rx="1.492"></rect></g><rect clip-path="url(#ipl-illustrations-spot-:r1o:-1)" width="100%" height="100%" fill="url(#ipl-illustrations-spot-:r1o:-0)"></rect></svg>
</div> */}

            {/* <div>
            <h2 className='text-xl  pb-2'><FormattedMessage id="RECRUITER.POSTJOB.REVIEW.APPLICATION_SETTINGS.TITLE" defaultMessage="Application settings" /></h2>
            <ReviewDataEdit title = {<FormattedMessage id="RECRUITER.POSTJOB.REVIEW.COUNTRYLANGUAGE.TITLE" defaultMessage="Country and language" />} multivalue={["United States", "English"] } onClick={()=> {openModel(15)}}></ReviewDataEdit>
            </div> */}
            <div className="mt-5 mb-5">
              <FormattedMessage
                id="RECRUITER.POSTJOB.JOB.AGREE.TEXT"
                defaultMessage="By pressing confirm, you agree that this job will be posted and applications will be processed in accordance with Indeed's Cookie Policy, Privacy Policy and Terms of Service. You consent to Indeed informing a user that you have opened, viewed or made a decision regarding the user’s application."
              />
            </div>
            <div className="flex justify-end">
              <button
                onClick={handleJob}
                className="rounded-lg bg-[#ff39b3] font-bold  p-2.5  text-white  w-32 cursor-pointer hover:bg-navy"
              >
                <FormattedMessage
                  id="RECRUITER.POSTJOB.REVIEW.PREVIEW.CONFIRM.BUTTON"
                  defaultMessage="Continue"
                />
              </button>
            </div>
          </ContentWithSpinner>
          <ModelWrapperWithButton
            Save={HandleSave}
            showModal={showModal}
            onCheckModel={HandleModel}
            headertitle="Edit the job post"
          >
            {
              <activeComponent.componentName
                HandleDataProps={HandleDataProps}
                data={jobData}
                ref={childRef}
              />
            }
          </ModelWrapperWithButton>
        </div>
      </div>
    </MainWrapper>
  );
};
